<template>
  <div style="display: inline-block;">
    <v-icon :class="iconClass" :right="right" :left="left" :large="large" :size="iconSize">{{icon}}</v-icon>
    <div style="position:relative;">
      <v-icon
        :class="rightTopIconClass"
        v-if="rightTopIcon"
        small
        style="position:absolute;right:-6px;top:-32px;"
        :color="rightTopIconColor"
      >{{rightTopIcon}}</v-icon>
      <v-icon
        class
        v-if="rightBottomIcon"
        small
        style="position:absolute;right:-5px;bottom:-5px;"
        :color="rightBottomIconColor"
      >{{rightBottomIcon}}</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiIcon",
  props: {
    icon: {
      type: String,
      default: "mdi-account",
    },
    iconClass: {
      type: String,
    },
    right: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: String,
      default: undefined,
    },
    rightTopIcon: {
      type: String,
    },
    rightTopIconClass: {
      type: String,
    },
    rightTopIconColor: {
      type: String,
    },
    rightBottomIcon: {
      type: String,
    },
    rightBottomIconColor: {
      type: String,
    },
  },
};
</script>
